module.exports = __webpack_public_path__ + "img/chart.abe593c6.svg";